import { render, staticRenderFns } from "./serviceLogs.vue?vue&type=template&id=6084e93c&scoped=true&"
import script from "./serviceLogs.vue?vue&type=script&lang=js&"
export * from "./serviceLogs.vue?vue&type=script&lang=js&"
import style0 from "./serviceLogs.vue?vue&type=style&index=0&id=6084e93c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6084e93c",
  null
  
)

export default component.exports